import {enableES5} from "immer";

const isMobileDevice = function () {
    if (typeof navigator !== 'undefined') {
        const userAgent = navigator.userAgent.toLowerCase();
        return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
    }
    return false;
}()

const runsOnServerSide = typeof window === 'undefined'

const userAgent = runsOnServerSide? '' : navigator.userAgent;
const chromeInfo = userAgent.match(/Chrome\/(\d+)/);
const chromeVersion = (chromeInfo && chromeInfo.length > 1)? Number(chromeInfo[1]) : 0;
// 低版本不支持es5的, 需要兼容
// todo 等新的设备能测试，可以降低版本
if(chromeVersion < 88) {
    enableES5();
}
const isIOS = !runsOnServerSide && /iPad|iPhone|iPod|iOS/.test(navigator.userAgent);
const isTG = process.env.NEXT_PUBLIC_TG === 'true'? true : false
const isTGIOS = isTG && isIOS
const screenW = runsOnServerSide? 0 : window.innerWidth;
// 后端 API 地址：优先取 NEXT_PUBLIC_API_HOST，未配置时取当前域名加 api. 前缀
const apiHost = (() => {
    if (process.env.NEXT_PUBLIC_API_HOST) {
        return process.env.NEXT_PUBLIC_API_HOST;
    }
    if (!runsOnServerSide) {
        const hostname = window.location.hostname.replace(/^www\./, '');
        return `${window.location.protocol}//tavern-api.${hostname}`;
    }
    return '';
})();
// 客户端登录标记 cookie 名。独立于服务端的 token cookie，避免同名覆盖导致接口转发读到错误的 token
const LOGIN_FLAG_COOKIE = 'login_flag'
export {
    LOGIN_FLAG_COOKIE,
    isMobileDevice,
    runsOnServerSide,
    chromeVersion,
    isIOS,
    isTG,
    isTGIOS,
    screenW,
    apiHost
}